import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import Container from '@mui/material/Container';

import BroadcastTemplates from "./BroadcasteTemplates";

const Broascast = (props) => {

  const [stableKey] = useState('broadcast-stable-instance');

  return (
    <div className="App">
      <Container maxWidth={false} sx={{backgroundColor:"#FAFAFA", pt:'17px'}}>
        <>
          {/* <h2 className="heading-title">Broadcast</h2> */}
          <BroadcastTemplates 
            key={stableKey}
            refreshkey={props.refreshKey}
            onNavigate={props.onNavigate}
            pageParams={props.pageParams}
          />
        </>
      </Container>

    </div>
  );
}
export default Broascast;
